export default __webpack_public_path__ + "static/media/image_4.62239d05.jpg";